/**
 * PlanBanner
 *
 * Replaces the wall that used to stand in front of the analytics pages.
 *
 * The wall was the wrong trade. Someone who reaches a page they cannot open
 * learns only that they are excluded; someone who sees three months of their
 * own market with the export button greyed out learns exactly what Standard
 * buys, while looking at the thing they came for. Paywall the depth and the
 * tools, never the subject.
 *
 * Renders nothing for accounts that already have the page in full.
 */

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { useAuth } from '../context/AuthContext';
import { useThemeMode } from '../context/ThemeContext';
import { hasAnalytics } from '../utils/planLimits';

function PlanBanner({ adds = [] }) {
  const { user } = useAuth();
  const { palette } = useThemeMode();

  if (hasAnalytics(user)) return null;

  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
        px: 2.25, py: 1.5, mb: 2.5, borderRadius: '12px',
        bgcolor: palette.accentBg, border: `1px solid ${palette.accent}33`,
      }}
    >
      <Icon icon="ph:sparkle" width={18} height={18} color={palette.accent} />
      <Box sx={{ flex: 1, minWidth: 220 }}>
        <Typography sx={{ fontSize: '0.86rem', fontWeight: 700, color: palette.text }}>
          You are on the Free plan
        </Typography>
        <Typography sx={{ fontSize: '0.8rem', color: palette.textSecondary, mt: 0.15 }}>
          {adds.length
            ? `Standard adds ${adds.join(', ')}.`
            : 'Standard adds the full price archive and the export tools.'}
        </Typography>
      </Box>
      <Button
        component={RouterLink}
        to="/app/subscription"
        variant="contained"
        size="small"
        disableElevation
        sx={{
          bgcolor: palette.accent, color: '#fff', fontWeight: 600,
          textTransform: 'none', borderRadius: '9px', whiteSpace: 'nowrap',
          '&:hover': { bgcolor: '#1C9550' },
        }}
      >
        See plans
      </Button>
    </Box>
  );
}

export default PlanBanner;
